var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('GenericSearchBar',{staticClass:"top-search-bar__input",attrs:{"tags":_vm.tagData,"selectedTags":_vm.getSelectedTags,"filter-model":_vm.filterState.filterModel},on:{"tagsChanged":_vm.onTagsChanged,"tagAdded":_vm.onTagAdded}}),_c('AllFiltersButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }